const productLinks = [
  { label: "电容器系列", id: "capacitor" },
  { label: "电感器系列", id: "inductor" },
  { label: "半导体元器件", id: "semiconductor" },
  { label: "光电元器件", id: "optoelectronic" },
  { label: "热电偶/热电阻", id: "thermocouple" },
  { label: "网络变压器", id: "transformer" },
  { label: "保护器件", id: "protection" },
];

const serviceLinks = [
  "技术选型支持",
  "样品申请",
  "质量保证",
  "物流配送",
  "售后服务",
];

const aboutLinks = [
  "公司简介",
  "资质认证",
  "新闻动态",
  "加入我们",
  "联系方式",
];

export default function Footer() {
  const handleAnchor = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const handleProductLink = (categoryId: string) => {
    window.dispatchEvent(new CustomEvent("setProductCategory", { detail: { id: categoryId } }));
    setTimeout(() => {
      const el = document.querySelector("#products");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 50);
  };

  return (
    <footer className="bg-[#0D1B2E] text-gray-400">
      {/* CTA Banner */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-12">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="text-white text-xl md:text-2xl font-bold mb-1">携手格睿特，共创智能制造未来</h3>
              <p className="text-gray-500 text-sm">专业元器件供应商，为您的产品研发保驾护航</p>
            </div>
            <button
              onClick={() => handleAnchor("#contact")}
              className="flex-shrink-0 flex items-center gap-2 px-8 py-3 bg-[#0EA5E9] hover:bg-[#0284C7] text-white text-sm font-semibold rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-send-line" />
              立即联系我们
            </button>
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 flex items-center justify-center overflow-hidden rounded-md bg-white/10">
                <img
                  src="https://static.readdy.ai/image/5f9cc22383cc9e7cc67ed543cf57b925/8fa99cba7f831135614307d2fb67ebf2.jpeg"
                  alt="格睿特电子 Logo"
                  className="w-10 h-10 object-contain"
                />
              </div>
              <div>
                <p className="text-white font-bold text-sm">格睿特电子</p>
                <p className="text-gray-500 text-xs tracking-wider">GERUITE ELECTRONICS</p>
              </div>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-6">
              厦门格睿特电子有限公司，专业电子元器件供应商，深耕行业多年，致力于为客户提供高品质的元器件产品与技术服务。
            </p>
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-2 text-sm">
                <i className="ri-map-pin-line text-[#0EA5E9] text-xs" />
                <span>厦门市集美区软件园三期B区02栋1203室</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <i className="ri-phone-line text-[#0EA5E9] text-xs" />
                <span>13860171140</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <i className="ri-mail-line text-[#0EA5E9] text-xs" />
                <span>williamge@xmgrt.com.cn</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <i className="ri-printer-line text-[#0EA5E9] text-xs" />
                <span>0592-2918131</span>
              </div>
            </div>
          </div>

          {/* Product links */}
          <div>
            <h4 className="text-white text-sm font-semibold mb-5">
              <a href="#products" onClick={(e) => { e.preventDefault(); handleProductLink("capacitor"); }} className="hover:text-[#0EA5E9] transition-colors duration-200 cursor-pointer">
                产品中心
              </a>
            </h4>
            <ul className="flex flex-col gap-3">
              {productLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href="#products"
                    onClick={(e) => { e.preventDefault(); handleProductLink(link.id); }}
                    className="text-sm hover:text-[#0EA5E9] transition-colors duration-200 cursor-pointer"
                    rel="nofollow"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Service links */}
          <div>
            <h4 className="text-white text-sm font-semibold mb-5">服务支持</h4>
            <ul className="flex flex-col gap-3">
              {serviceLinks.map((link) => (
                <li key={link}>
                  <a
                    href="#contact"
                    onClick={(e) => { e.preventDefault(); handleAnchor("#contact"); }}
                    className="text-sm hover:text-[#0EA5E9] transition-colors duration-200 cursor-pointer"
                    rel="nofollow"
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* About links */}
          <div>
            <h4 className="text-white text-sm font-semibold mb-5">关于我们</h4>
            <ul className="flex flex-col gap-3">
              {aboutLinks.map((link) => (
                <li key={link}>
                  <a
                    href="#about"
                    onClick={(e) => { e.preventDefault(); handleAnchor("#about"); }}
                    className="text-sm hover:text-[#0EA5E9] transition-colors duration-200 cursor-pointer"
                    rel="nofollow"
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom copyright */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-600 text-xs">
            © 2025 厦门格睿特电子有限公司 · 版权所有
          </p>
          <div className="flex items-center gap-4 text-gray-600 text-xs">
            <span>专业电子元器件供应商</span>
            <span>·</span>
            <span>厦门 · 福建</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
